import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import * as Cropper from '../../../../assets/cropper.min.js';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-cropper-img',
  templateUrl: './cropper-img.component.html',
  styleUrls: ['./cropper-img.component.scss', '../../../../assets/cropper.min.css'],
  encapsulation: ViewEncapsulation.None // 样式不进行封装
})
export class CropperImgComponent implements OnInit {
  @Input() width;  // 裁剪的宽度
  @Input() height;  // 裁剪的高度
  @Input() imgUrl; // 回显图片url
  @Output() getImgUrl: EventEmitter<any> = new EventEmitter();  // 裁剪后传给father的图片对象

  @ViewChild('imageInput') imgInput: ElementRef; // input=file的事件容器
  @ViewChild('imgCropper') imgCropper: ElementRef; // 装裁剪图片的容器
  myCropper: any; // 当前的裁剪对象
  croppedImage: any = ''; // 当前实时裁剪后的base64
  nowRotate = 0; // 旋转度数

  constructor(
    private message: NzMessageService
  ) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.imgCropper.nativeElement.src = this.imgUrl;
      this.iniCropper();
    }, 500);
  }

  imageChangeEvent(event: any): void {
    // console.log(event);
    const fr = new FileReader();
    fr.readAsDataURL(event.target.files[0]);
    fr.onload = () => {
      this.imgCropper.nativeElement.src = fr.result;
      this.iniCropper();
    };
  }

  iniCropper() {
    this.myCropper = new Cropper(this.imgCropper.nativeElement, {
      aspectRatio: (this.width && this.height) ? this.width / this.height : 'auto',
      dragMode: 'move',
      viewMode: 1,
      autoCropArea: 1,
      // preview: '.preImg',//自动存放原图供预览，定义一个div用class名即可
      // 其他还有很多属性,可以参见官方文档或文章末尾
      crop: event => {
        this.croppedImage = this.myCropper.getCroppedCanvas({ // 直接转了base64
          imageSmoothingQuality: 'high'
        }).toDataURL('image/png');
      },
      replace: event => {
        if (this.imgUrl) {
          this.myCropper.replace(this.imgUrl);
        }
      }
    });
    this.myCropper.replace(this.imgCropper.nativeElement.src);
  }

  rotateImage() {
    this.nowRotate += 90;
    this.myCropper.rotateTo(this.nowRotate);
  }

  sureCropper() {
    // this.base64toFile(this.croppedImage)//可以自己将base64转file对象然后传输
    // console.log(this.base64toFile(this.croppedImage))
    this.uploadImg();
    // this.imgInput.nativeElement.value = ''; // 补坑，防止第二次点击不触发imageChangeEvent事件

  }

  base64toFile() { // 将base64转换为文件
    const base = this.croppedImage;
    const arr = base.split(',');
    const  mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while ( n-- ) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const filename = new Date().getTime();
    return new File([u8arr], filename + '.png', { type: mime });
  }

  uploadImg() {
    const file = this.base64toFile();
    // formData.append('file', file);
    // formData.append('type', '3');
    // this.res.post(ApiService.common_post_commonFileUpload, formData).subscribe(res => {
    //   this.message.success('上传成功');
    //   // 向父组件传值
    //   this.getImgUrl.emit(res.data);
    // });
    this.getImgUrl.emit(file);
  }

}
